import times from 'lodash-es/times'
import React, { memo } from 'react'

import { List } from '@fourthwall/components'

import { ProductsListItem } from '../ProductsListItem/ProductsListItem'

type LoadingListProps = {
  count: number
}

const MemoizedSkeletonItem = memo(ProductsListItem.Skeleton)

export const LoadingList = memo(({ count }: LoadingListProps) => (
  <List
    data={times(count, String)}
    bottomBorder={false}
    renderItem={() => <MemoizedSkeletonItem />}
  />
))
